// extracted by mini-css-extract-plugin
module.exports = {"dot":"styles_dot__RJGbO","active":"styles_active__3LDFf"};